"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomesticReviewListPageRequestSchemaV2 = exports.DomesticReviewListPageRequestSchema = exports.DomesticReviewListPageQueryV2 = exports.DomesticReviewListPageQuery = exports.DomesticReviewListPageResources = void 0;
var zod_1 = require("zod");
var sort_option_1 = require("../sort-option");
exports.DomesticReviewListPageResources = zod_1.z.object({
    propertyId: zod_1.z.number(),
});
exports.DomesticReviewListPageQuery = zod_1.z.object({
    page: zod_1.z.number().optional(),
    roomTypeIds: zod_1.z.array(zod_1.z.number()),
    isPhotoReviewOnly: zod_1.z.boolean().optional(),
    sort: zod_1.z
        .union([
        zod_1.z.literal(sort_option_1.DOMESTIC_SORT_OPTION['recommend:asc'].code),
        zod_1.z.literal(sort_option_1.DOMESTIC_SORT_OPTION['created-at:desc'].code),
        zod_1.z.literal(sort_option_1.DOMESTIC_SORT_OPTION['best:desc'].code),
        zod_1.z.literal(sort_option_1.DOMESTIC_SORT_OPTION['score:desc'].code),
        zod_1.z.literal(sort_option_1.DOMESTIC_SORT_OPTION['score:asc'].code),
    ])
        .optional(),
});
exports.DomesticReviewListPageQueryV2 = zod_1.z.object({
    page: zod_1.z.number().optional(),
    roomTypeIds: zod_1.z.array(zod_1.z.number()),
    isPhotoReviewOnly: zod_1.z.boolean().optional(),
    sort: zod_1.z
        .union([
        // TODO 후기 작성 개편 이후 삭제 필요
        zod_1.z.literal(sort_option_1.DOMESTIC_SORT_OPTION['recommend:asc'].code),
        zod_1.z.literal(sort_option_1.DOMESTIC_SORT_OPTION['created-at:desc'].code),
        zod_1.z.literal(sort_option_1.DOMESTIC_SORT_OPTION['best:desc'].code),
        zod_1.z.literal(sort_option_1.DOMESTIC_SORT_OPTION['score:desc'].code),
        zod_1.z.literal(sort_option_1.DOMESTIC_SORT_OPTION['score:asc'].code),
        zod_1.z.literal(sort_option_1.REVIEW_PLATFORM_SORT_OPTION.RECOMMEND.code),
        zod_1.z.literal(sort_option_1.REVIEW_PLATFORM_SORT_OPTION.HOST_CHOICE.code),
        zod_1.z.literal(sort_option_1.REVIEW_PLATFORM_SORT_OPTION.LATEST.code),
        zod_1.z.literal(sort_option_1.REVIEW_PLATFORM_SORT_OPTION.HIGH_RATING.code),
        zod_1.z.literal(sort_option_1.REVIEW_PLATFORM_SORT_OPTION.LOW_RATING.code),
    ])
        .optional(),
});
exports.DomesticReviewListPageRequestSchema = zod_1.z.object({
    resources: exports.DomesticReviewListPageResources,
    query: exports.DomesticReviewListPageQuery,
});
exports.DomesticReviewListPageRequestSchemaV2 = zod_1.z.object({
    resources: exports.DomesticReviewListPageResources,
    query: exports.DomesticReviewListPageQueryV2,
});
